import React from "react";
import loader from "../Loader2/loader.gif";
function Loader() {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img src={loader} alt="Loading"  />
    </div>
  );
}

export default Loader;
